import React from 'react'
import { Modal } from 'theorem-lib/src/components/molecules/Modal/Modal'
import { useActions, useAppState } from '../../../presenter'

export function DeleteClientModal() {
  const { currentModal } = useAppState()
  const { deleteClientAction, displayModalAction } = useActions()

  const onClose = () => displayModalAction('None')
  const onDelete = () => deleteClientAction()

  return (
    <Modal
      isOpen={currentModal === 'DeleteClientModal'}
      onClose={onClose}
    >
      <div className='flex flex-col justify-center items-center w-[80vw] sm:w-[558px]'>
        <div className='text-primary-100 text-xl font-semibold mb-2 text-center'>
          Are you sure you want to delete this client?
        </div>
        <div className='text-primary-300 text-base font-normal text-center mb-6'>
          Deleting this client will permanently remove the client and all associated projects and project data. You
          can’t undo this once it’s confirmed.
        </div>
        <div className='flex flex-row'>
          <button type='button' className='button mx-2' onClick={onClose}>Cancel</button>
          <button type='button' className='button cta mx-2' onClick={onDelete}>Delete</button>
        </div>
      </div>
    </Modal>
  )
}
